<template>
  <div class="dc_0">
    <!-- 单个打印动图 -->
    <div class="text" v-if="resultFrom.batchType == 1 && resultFrom.printStatus == 2">
      <div class="dc_2">
        <van-image round width="55" height="55" fit="cover" :src="ptingIcon" />
      </div>
      <p>正在打印快递面单，请您耐心等待结果</p>
    </div>
    <!-- 批量多个打印中动图 -->
    <div class="text" v-if="resultFrom.batchType == 2 && resultFrom.printStatus == 2">
      <!-- <div class="dc_2">
        <van-progress :percentage="percentage" color="#F8A651"/>
      </div> -->
      <div class="dc_2">
        <van-image round width="55" height="55" fit="cover" :src="ptingIcon" />
      </div> 
      <p>批量打印中...请您耐心等待结果</p>
      <p>已成功打印 <span class="org">{{resultFrom.successCount}}</span>张</p>
      <p>还有<span class="red">{{resultFrom.totalCount - resultFrom.successCount}}</span>张待打印</p>
    </div>
    <!-- 全部或者批量打印成功结果提示 -->
    <div class="text" v-if="(resultFrom.printingCount == 0 && resultFrom.printStatus == 4) || (resultFrom.printingCount == 0 && resultFrom.printStatus == 5)">
      <div class="dc_2">
        <van-image style="vertical-align: middle;" round width="50" height="50" fit="cover" :src="yesIcon" />
        <span class="ml20">{{successPrintStatusFormart[resultFrom.printStatus]}}打印成功</span>
      </div>
      <p>总共扫描到<span>{{resultFrom.totalCount}}</span>条发货订单</p>
      <p>成功打印<span class="org">{{resultFrom.successCount}}</span>条发货订单</p>
      <p>失败打印<span class="red">{{resultFrom.failCount}}</span>条发货订单</p>
    </div>
    <!-- 全部打印失败结果过提示-->
    <div class="text" v-if="resultFrom.printingCount == 0 && resultFrom.printStatus == 3">
      <div class="dc_2">
        <van-image style="vertical-align: middle;" round width="50" height="50" fit="cover" :src="noIcon" />
        <span class="ml20">全部打印失败</span>
      </div>
      <p>总共扫描到<span>{{resultFrom.successCount}}</span>条发货订单</p>
      <p>成功打印<span class="org">0</span>条发货订单</p>
      <p>失败打印<span class="red">{{resultFrom.failCount}}</span>条发货订单</p>
    </div>
    <div :class="['dc_1 ', printStatusFormat[resultFrom.printStatus] ? 'mar-t': 'mar-t2']">
      <div class="dc_3">
        <van-image width="250" height="300" fit="cover" :src="form.codeImageUrl" />
      </div>
      <p class="dc_4" v-if="needReprint == 1">如快递面单已损毁或丢失，可扫码重新打印快递面单</p>
      <p class="dc_4">分享给业务员扫一扫打印</p>
      <p class="dc_4" v-if="needReprint != 1">温馨提示：请打印后确认打印面单结果是否打印，避免丢失面单</p>
    </div>
    <div>
      <div @click="savePringCodeFun" class="dc_2">
        <van-image round width="55" height="55" fit="cover" :src="pdownIncon" />
      </div>
      <p @click="savePringCodeFun">保存图片</p>
    </div>
  </div>
</template>
<script>
import Util from "@/utils/common";
import env from "@/utils/env"
import http from "@/utils/axios";
export default {
  name: '',
  props: {
    form: {
      type:Object,
      default:()=>{
        return {}
      },
      required: true
    },
    needReprint:{
      type:[Number, String],
      default:''
    }
  },
  data() {
    return {
      pdownIncon: require("@/assets/image/cdown.png"),
      ptingIcon: require("@/assets/image/print.gif"),
      yesIcon: require("@/assets/atlas/clope@2x.png"),
      noIcon: require("@/assets/atlas/clode@2x.png"),
      percentage: 0,
      inteervalTime: null,
      resultFrom:{
        batchType: 1, //是否批量 1 单个 2 批量
        failCount: 0,
        printStatus: 0,
        printingCount: 0,
        successCount: 0,
        totalCount: 0,
      },
      batchTypeFormat: {
        1: '单个打印',
        2: '批量打印'
      },
      printStatusFormat:{
        0: true,
        1: true,  // 'SCANCODE(1,"已扫码")',
        2: false, //'PRINTING(2,"打印进行中")',
        3: false, //'ALLFAIL(3,"全部失败")',
        4: false, //'PARTSUCCESS(4,"部分成功")',
        5: false //'ALLSUCCESS(5,"全部成功")'
      },
      successPrintStatusFormart:{
        4: '部分',
        5: '全部'
      }
    }
  },
  methods: {
    savePringCodeFun() {
      Util.nativeMethod({
        tm: "3050001",
        tp: { urls: [this.form.codeImageUrl] },
      });
    },
    closeFun(){
      clearInterval(this.inteervalTime);
    },
    doSubmit(){
      http({
        url: "order/express/printCode/getPrintResult",
        method: "POST",
        parmes:{
          needReprint: this.needReprint,
          printCodeNo: this.form.printCodeNo
        }
      })
        .then((rps) => {
          if (rps.code === 200) {
            for (const key in this.resultFrom) {
              this.resultFrom[key] = rps.data[key]
            }
            //this.redern(rps.data)
          }
        })
        .catch((rps) => {});
    },
    render(rps){
      if(rps.batchType == 2){
        this.percentage = parseInt((rps.successCount / rps.totalCount) * 100);
        if(this.percentage >= 100){
          this.percentage = 100
        }
      }
    },
    eachPrintResultFun(){
      this.inteervalTime = setInterval(()=>{
        this.doSubmit()
      },1000)
    }
  },
  created() {
    //待收货的重打快递码不用轮询
    this.needReprint != 1 && this.eachPrintResultFun()
  },
  watch:{
    'resultFrom.printStatus'(val,oldval){
      if(val == 3 || val == val == 4 || val == 5){
        clearInterval(this.inteervalTime);
      }
    },
  },
  destroyed(){
    clearInterval(this.inteervalTime);
  },
  mounted(){},
  computed:{},
  components: {},
};
</script>
<style lang="less" scoped>
.dc_0 {
  font-size: 24px;
  margin: 0 auto;
  color: #333333;
  text-align: center;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .mar-t{
    margin-top: 117px;
  }
  .mar-t2{
    margin-top: 10px;
  }
  .dc_1 {
    width: 530px;
    height: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
    padding: 30px;
  }
  .dc_4 {
    color: #999999;
  }
  .dc_2 {
    width: 280PX;
    margin-top: 66px;
    margin-bottom: 10px;
  }
  .text{
    p{
      font-size: 32px;
    }
  }
  .ml20{
    margin-left: 20px;
  }
  .org{
    color: #F8A651;
    font-weight: bold;
  }
  .red{
    color:#ED3939;
    font-weight: bold;
  }
}
</style>
